import React from 'react';

const AprendeLicitar = ({ user }) => {
  return (
    <div style={{ 
      width: '100%', 
      height: 'calc(100vh - 60px)', // Ajusta según la altura de tu navbar
      overflow: 'hidden',
      position: 'relative'
    }}>
      {/* Header opcional con información */}
      <div style={{
        padding: '15px 20px',
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <span style={{ fontSize: '24px' }}>🎓</span>
          <div>
            <h4 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
              Aprende a Licitar
            </h4>
            <p style={{ margin: 0, fontSize: '13px', opacity: 0.9 }}>
              Plataforma completa de aprendizaje sobre licitaciones públicas
            </p>
          </div>
        </div>
        
        <a 
          href="https://cursoslicitacioneslive.lovable.app/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            padding: '8px 16px',
            background: 'rgba(255,255,255,0.2)',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '8px',
            color: 'white',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(255,255,255,0.3)';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(255,255,255,0.2)';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          <span>🔗</span>
          Abrir en nueva pestaña
        </a>
      </div>

      {/* iframe embebido */}
      <iframe
        src="https://cursoslicitacioneslive.lovable.app/"
        title="Aprende a Licitar - Plataforma de Cursos"
        style={{
          width: '100%',
          height: 'calc(100% - 70px)', // Resta la altura del header
          border: 'none',
          display: 'block'
        }}
        allow="fullscreen"
        loading="lazy"
      />
      
      {/* Indicador de carga opcional */}
      <div 
        id="loading-indicator"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'none' // Se mostrará con JavaScript si es necesario
        }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    </div>
  );
};

export default AprendeLicitar;